import { Avatar, Box, Flex, Stack, Text } from "@chakra-ui/react";
import { distanceInWordsStrict as timeAgo } from "date-fns";
import * as React from "react";
import Dot from "./layout/Dot";
import { SHOW_EARNINGS_ACTION } from "../stores/jobs/utils/request";
import BookingStatus from "./BookingStatus";
import EarningSummary from "./EarningSummary";
import { observer } from "mobx-react-lite";
import { ILessonPaymentStore } from "../stores/types";

type Props = {
  client: {
    title: string;
    firstName: string;
    state: string;
    country?: string;
    vicinity?: string;
    region?: string;
    photo?: string;
  };
  billingInfo?: ILessonPaymentStore;
  lessonInfo: any;
  showBreakdown: boolean;
  dateCreated: any;
  openModal?: (action: string) => void;
  requestStatus: string;
  lostRequest: any;
  requestSLUG: string;
  tutorResponse?: any;
  [key: string]: any;
};

const BookingCardHeader: React.FC<Props> = ({
  client,
  billingInfo,
  lessonInfo = {},
  showBreakdown,
  dateCreated,
  openModal = () => {},
  requestStatus,
  lostRequest,
  requestSLUG,
  tutorResponse,
  display = true,
  ...rest
}) => {
  const clientName = `${client.title} ${client.firstName}`;
  const isOnlineLesson = lessonInfo.lessonType === "online";
  const clientLocation = isOnlineLesson
    ? `${client.state}, ${client.country}`
    : `${client.vicinity}, ${client.region}`;
  const timeDifference = timeAgo(new Date(dateCreated), new Date());
  if (billingInfo) {
    console.log("Billinginfo", (billingInfo as any).toJSON());
  }
  return (
    <Stack spacing={[4, 5]} {...rest}>
      <Flex direction={["column", "row"]}>
        <Stack px={[5, 6]} isInline align="center" flex={1}>
          <Avatar src={client.photo} name={clientName.trim()} />
          <Box>
            <Text fontWeight="medium">{clientName}</Text>
            <Stack opacity={0.7} fontSize="sm" isInline align="center">
              <Text>{clientLocation}</Text>
              <Dot />
              <Text>{timeDifference} ago</Text>
            </Stack>
          </Box>
        </Stack>

        <Box boxSize={[3, 2]} />

        {showBreakdown && !lostRequest ? (
          <Box
            _hover={{ cursor: "pointer" }}
            onClick={() => openModal(SHOW_EARNINGS_ACTION)}
          >
            {billingInfo ? (
              <EarningSummary
                billingInfo={billingInfo}
                lessonInfo={lessonInfo}
                showBreakdown={showBreakdown}
              />
            ) : null}
          </Box>
        ) : (
          <>
            {billingInfo ? (
              <EarningSummary
                billingInfo={billingInfo}
                lessonInfo={lessonInfo}
                lostRequest={lostRequest}
                showBreakdown={showBreakdown}
              />
            ) : null}
          </>
        )}
      </Flex>

      {showBreakdown && display && (
        <BookingStatus
          tutorResponse={tutorResponse}
          requestStatus={requestStatus}
          requestSLUG={requestSLUG}
          dateCreated={dateCreated}
        />
      )}
    </Stack>
  );
};

export default observer(BookingCardHeader);
